import { i18n } from 'beans-admin-plugin/i18n';

// 修改 message 例子
// i18n.setLocaleMessage('zh_cn', { ...zh_cn, 表格设置: '表格sz' })

// 语言环境变更例子
// i18n.locale = 'en'

export default i18n
